import { DefaultService } from '@/services/DefaultService';

export default class FeriadosService extends DefaultService {

    constructor(http, router, env) {
        super(http, router, env)
    }

    save(cliente) {
        return this._http.post(`${this._env}/holidays`, cliente, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    find(id) {
        return this._http.get(`${this._env}/holidays/${id}.json`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    delete(id) {
        return this._http.delete(`${this._env}/holidays/${id}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    updateSituacao(feriado) {
        return this._http.post(`${this._env}/holidays/updatesituacao`, feriado, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAll(column, order,page = 0, limit = 50, ...params) {
        return this._http.get(encodeURI(`${this._env}/holidays.json?page=${page}&column=${column}&order=${order}&limit=${limit}&param=${params}`), this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }

    findAllNaoAssociadosByTurno(idturno, situacao, column = 'descricao', order='desc', page = 0, limit = 50, ...param) {
        return this._http.get(`${this._env}/holidays/findAllNaoAssociadosByTurno/${idturno}.json?situacao=${situacao}&order=${order}&column=${column}&page=${page}&limit=${limit}&param=${param}`, this._headers).then(res => {
            return res.body;
        }, err => {
            this.verifyError(err);
            throw new Error('Problems while jobs are loading');
        });
    }
}